var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/SourceItem/SourceItem.tsx";
import "core-js/modules/es.function.name.js";
import { SourceItemStyled, RemoveButton, Space, SourceNumber } from "./SourceItem.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SourceItem = function SourceItem(_ref) {
  var icon = _ref.icon,
      source = _ref.source,
      onRemove = _ref.onRemove;
  var isAllModels = source.type === 'ALL_MODELS';
  return /*#__PURE__*/_jsxs(SourceItemStyled, {
    children: [icon, " ", source.name, !isAllModels ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [source.depNumber !== null && /*#__PURE__*/_jsx(SourceNumber, {
        children: source.depNumber
      }), /*#__PURE__*/_jsx(RemoveButton, {
        onClick: onRemove,
        color: "rgba(76, 94, 207, 0.5)"
      })]
    }) : /*#__PURE__*/_jsx(Space, {})]
  });
};